<template>
  <!--추가 설명 -->
  <div class="">
    <card class="mt-15">
      <div slot="header">
        <h3 class="card-title">추가 설명</h3>
      </div>
      <el-input
        v-model="extrExpl"
        type="textarea"
        :rows="4"
        placeholder="매물에 대한 추가 설명을 작성해주세요."
        @input="SendData()"
      ></el-input>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);
import { Card, Input } from "element-ui";
export default {
  components: {
    Card,
    [Input.name]: Input
  },

  data() {
    return {
      extrExpl: null //추가설명
    };
  },

  created() {},

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },

  methods: {
    bringData() {
      this.extrExpl = this.sessionPropertyInquiry.propertyInfo.extrExpl; //추가설명
    },
    SendData(event) {
      this.$emit("extrExpl", event);
    }
  }
};
</script>

<style></style>
